import { render, staticRenderFns } from "./dialog-confirmEmptyTrashAll-inbox.vue?vue&type=template&id=b9ae020e&"
import script from "./dialog-confirmEmptyTrashAll-inbox.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmEmptyTrashAll-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports